/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Btn_SkipInputs */

const es_walkthrough_btn_skip = /** @type {(inputs: Walkthrough_Btn_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saltar Tour`)
};

const en_walkthrough_btn_skip = /** @type {(inputs: Walkthrough_Btn_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skip Tour`)
};

/**
* | output |
* | --- |
* | "Skip Tour" |
*
* @param {Walkthrough_Btn_SkipInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_btn_skip = /** @type {((inputs?: Walkthrough_Btn_SkipInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Btn_SkipInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_btn_skip(inputs)
	return en_walkthrough_btn_skip(inputs)
});
export { walkthrough_btn_skip as "walkthrough.btn_skip" }